import { getLocale } from "../runtime";

const sv_campaignexpirestoday = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kampanjen slutar idag!`
};

const campaignexpirestoday = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_campaignexpirestoday(inputs)
	return "campaignExpiresToday";
};

export { campaignexpirestoday as "campaignExpiresToday" };